import axios from "axios";

const api = axios.create({
  baseURL: "https://db-fluxoeasy-idq9.onrender.com/api", // http://localhost:5000/api ou https://db-fluxoeasy-idq9.onrender.com/api
});

// Interceptor para adicionar token JWT em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config; // importante!
});

export default api;
